import $ from 'jquery';
import ACTION from '../action_constant';
import {ajaxPost,ajaxGet,ajaxPostWithToken,ajaxGetWithToken, ajaxDeleteWithToken} from '../util/ajax';
import API from '../api_config';

const paymentActions = {
    getAllCards : function(){
      return function(dispatch){
        return ajaxGetWithToken({
          url : API.getAllCards,
          success : function(data){
            dispatch({
              type : ACTION.PAYMENT.ADD_DETAILS,
              data : data
            })
          }
        });
      }
    },
    addCard : function(paramObj){
      return function(dispatch){
        return ajaxPostWithToken({
          url : API.addCard,
          data : paramObj,
          success : function(data){
          }
        });
      }
    },
    removeCard : function(cardId,cardIndx){
      return function(dispatch){
        return ajaxDeleteWithToken({
          url : API.deleteCard+ '?cardId=' + cardId,
          success: function(){
              dispatch({
                type : ACTION.PAYMENT.DELETE_CARD,
                cardIndx
              });
          }
        });
      }
    },
    updateDefaultCard : function(paramObj){
    return function(dispatch){
      return ajaxPostWithToken({
        url : API.updateDefaultCard,
        data : paramObj,
        success: function(){
          dispatch({
            type : ACTION.PAYMENT.UPDATE_DEFAULT_CARD,
            paramObj
          });
        }
      });
    }
  }
}


module.exports = paymentActions;



// WEBPACK FOOTER //
// app/payment/payment_actions.jsx